"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "atena-lucana": {
    "17a1a78f": [{
      "hkey": "4698eef3",
      "slug": "taverne",
      "name": "Taverne",
      "primary": true,
      "skipSearch": false
    }],
    "atena-lucana-scalo": [{
      "hkey": "4698eef3",
      "slug": "taverne",
      "name": "Taverne",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dcfe57d9": [{
      "hkey": "7964bf35",
      "slug": "atena-lucana",
      "name": "Atena Lucana",
      "primary": true,
      "skipSearch": false
    }],
    "fiego": [{
      "hkey": "7964bf35",
      "slug": "atena-lucana",
      "name": "Atena Lucana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce730869": [{
      "hkey": "7964bf35",
      "slug": "atena-lucana",
      "name": "Atena Lucana",
      "primary": true,
      "skipSearch": false
    }],
    "maglianello": [{
      "hkey": "7964bf35",
      "slug": "atena-lucana",
      "name": "Atena Lucana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;